<ng-container *ngIf="currentFeature">
  <ng-container [ngSwitch]="currentFeature.layer.metadata.component">
    <ng-container *ngSwitchCase="'ElementDetailsComponent'">
      <qm-element-details #inner [currentFeature]="currentFeature"></qm-element-details>
    </ng-container>
    <ng-container *ngSwitchCase="'TrainInfoComponent'">
      <qm-vrgroup-train-info #inner [currentFeature]="currentFeature" [openTab]="params.openTab" (trainChange)="refreshTitle()"></qm-vrgroup-train-info>
    </ng-container>
    <ng-container *ngSwitchCase="'StationInfoComponent'">
      <qm-vrgroup-station-info #inner [currentFeature]="currentFeature"></qm-vrgroup-station-info>
    </ng-container>
  </ng-container>
</ng-container>
